import createMessage from "./createMessage";
import protoRoot from "../proto-root";

const name = "webRTCCreateOffer";

function create({ sdp }) {
  const WebRTCCreateOfferMessage = protoRoot.lookupType(
    `comm.WebRTCCreateOfferMessage`
  );
  const webRTCCreateOfferMessage = WebRTCCreateOfferMessage.create({ sdp });

  return createMessage({
    [name]: webRTCCreateOfferMessage
  });
}

export default {
  create,
  name
};
